export enum PermissionMode {
  CREATE = 'create',
  EDIT = 'edit',
  GROUP = 'group',
  QUANTIFICATION = 'quantification',
  CREATE_BY_LIST = 'create_by_list'
}

export enum PermissionAllowMode {
  CREATE = 'Create',
  EDIT = 'Edit'
}

export enum NotificationPermissionMode {
  CREATEWEBAPP = 'create-web-app',
  CREATEEMAIL = 'create-email',
  EDITWEBAPP = 'edit-web-app',
  EDITEMAIL = 'edit-email'
  }
